import { render, staticRenderFns } from "./PlacementHistoryTable.vue?vue&type=template&id=548c37f1"
import script from "./PlacementHistoryTable.vue?vue&type=script&lang=js"
export * from "./PlacementHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports